export default __webpack_public_path__ + "static/media/brand-22.00cb9151.png";